// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 56,
  H_DESKTOP: 60,
  H_DESKTOP_OFFSET: 72 - 16,
};

export const NAV = {
  W_VERTICAL: 200,
  W_VERTICAL_MOBILE: 240,
  W_MINI: 100,
};
